import * as React from 'react';
import type { SVGProps } from 'react';
const SvgContrast01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 3.055c.19.02.377.048.563.08a1 1 0 1 0 .344-1.97A11.063 11.063 0 0 0 12 1C5.925 1 1 5.925 1 12s4.925 11 11 11c.649 0 1.286-.056 1.905-.165a1 1 0 0 0-.344-1.97 9.036 9.036 0 0 1-.561.08V3.055Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M16.92 3.235a1 1 0 0 1 1.392-.245 11.058 11.058 0 0 1 2.7 2.701 1 1 0 0 1-1.637 1.149 9.056 9.056 0 0 0-2.212-2.212 1 1 0 0 1-.244-1.393ZM21.678 9.28a1 1 0 0 1 1.157.813 11.063 11.063 0 0 1 0 3.814 1 1 0 1 1-1.97-.345 9.063 9.063 0 0 0 0-3.124 1 1 0 0 1 .813-1.157ZM20.764 16.922a1 1 0 0 1 .244 1.393 11.054 11.054 0 0 1-2.697 2.695 1 1 0 1 1-1.148-1.637 9.055 9.055 0 0 0 2.208-2.207 1 1 0 0 1 1.393-.244Z"
    />
  </svg>
);
SvgContrast01.displayName = 'Contrast01';
export default SvgContrast01;
